const initStat = {
	isStarted: false,
};

const TourReducer = (state = initStat, action) => {
	if (action.type === 'TOUR') {
		return {
			isStarted: action.payload,
		};
	}

	return state;
};

export default TourReducer;
